import { get } from '../utils/axios';

export const fetchInspectors = async () => {
  const { data } = await get(`/inspectors/stats`);
  return data;
};
